import currentPageIsCheckout from './../../Checkout/Pages/Checkout/current-page-is-checkout';
export default (state) => {
    return currentPageIsCheckout(state.currentPage);
};
